exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7a72a7af] table > tbody > tr > td:first-child {\n  width: 32px !important;\n  padding: 0;\n}\n[data-v-7a72a7af] table > tbody > tr > td:last-child {\n  width: 120px !important;\n}\n.table .md-round[data-v-7a72a7af] {\n  margin: 0 3px;\n}\n.custom-tooltip-container[data-v-7a72a7af] {\n  display: inline-block;\n}\n.md-tooltip-top.toggle-tooltip[data-v-7a72a7af] {\n  margin-left: 20px !important;\n}\n.member-code[data-v-7a72a7af] {\n  font-size: 11px;\n  color: #666;\n}\n", ""]);

// exports
